import { useAppSelector } from 'flex/utils';
import { useContext, useEffect } from 'react';
import * as Actions from 'flex/Actions';
import { ListContext } from '.';

// ユーザー一覧取得結果を ListContext に反映する effect component
export const UserEffectComponent: React.FC = () => {
    const [, setList] = useContext(ListContext);
    const usersSearchConnection = useAppSelector(
        (state) => state.usersSearchConnection,
    );

    useEffect(() => {
        if (usersSearchConnection.meta.status === Actions.statusEnum.SUCCESS) {
            setList((prev) => ({
                ...prev,
                usersList: usersSearchConnection.payload.result.items,
                usersListItemCount:
                    usersSearchConnection.payload.result.item_count,
            }));
        }
    }, [usersSearchConnection]); // eslint-disable-line react-hooks/exhaustive-deps

    return null;
};
